import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SourceForm from '../components/SourceForm';
import DismissableInfoCard from '../components/DismissableInfoCard';
import { useAuth } from '../contexts/AuthContext';

export default function AddSourcePage() {
    const { authFetch } = useAuth();
    const [hasExistingSources, setHasExistingSources] = useState<boolean | null>(null);
    const [searchParams] = useSearchParams();
    const typeFilter = searchParams.get('type') ?? '';

    useEffect(() => {
        authFetch('/sources')
            .then(res => res.ok ? res.json() : [])
            .then(data => setHasExistingSources(Array.isArray(data) && data.length > 0))
            .catch(() => setHasExistingSources(false));
    }, []);

    const title = hasExistingSources ? 'Connect a new source' : 'Add your first data source';

    return (
        <div>
            <div className="pb-6 mb-6 border-b border-softgrey">
                <h3 className="text-lg font-semibold text-graphite">{title}</h3>
                <p className="text-coolslate text-sm mt-1">Select a source type and configure it to get started</p>
            </div>
            <div className="mx-auto max-w-2xl">
                <DismissableInfoCard
                    storageKey="addSource.introDismissed"
                    title="What connecting a source does"
                >
                    Connecting a document store lists its <strong>filenames and folder names</strong>.
                    After each sync Navaris files the documents worth having and reads them into the
                    record, and dismisses matches that are not your documents; the rest stay on the
                    source's Candidates tab for you to file or dismiss. Turn off <strong>File the
                    documents Navaris recommends</strong> below to see its recommendations there and
                    file them yourself. Connecting a data source such as Xero imports the
                    relevant <strong>data</strong> directly.
                </DismissableInfoCard>
                {/* Keyed by typeFilter so changing type fully resets SourceForm's internal state. */}
                <SourceForm key={typeFilter} />
            </div>
        </div>
    );
}
